import React from "react";
import { AbsoluteFill, useCurrentFrame, interpolate, Easing } from "remotion";
import { Backdrop, Brand } from "../components";
import { COLORS, FONT, NEUTRAL, SAFE } from "../theme";

export const S8CTA: React.FC = () => {
  const frame = useCurrentFrame();
  const ctaOp = interpolate(frame, [28, 46], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const ctaY = interpolate(frame, [28, 48], [30, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.16, 1, 0.3, 1) });
  const btnPop = interpolate(frame, [40, 58], [0.8, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp", easing: Easing.bezier(0.16, 1, 0.3, 1) });
  const btnOp = interpolate(frame, [40, 54], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
  const domainOp = interpolate(frame, [58, 74], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });

  return (
    <AbsoluteFill>
      <Backdrop tint="mix" />
      <AbsoluteFill style={{ justifyContent: "center", alignItems: "center", padding: SAFE }}>
        <Brand scale={1.15} />
        <div
          style={{
            fontFamily: FONT,
            fontWeight: 800,
            fontSize: 64,
            color: COLORS.white,
            marginTop: 60,
            textAlign: "center",
            letterSpacing: -1.5,
            opacity: ctaOp,
            translate: `0px ${ctaY}px`,
            maxWidth: 1300,
            textWrap: "balance",
          }}
        >
          Digitaliza la logística de tu flota
        </div>

        <div
          style={{
            marginTop: 54,
            padding: "26px 58px",
            borderRadius: 60,
            background: `linear-gradient(90deg, ${COLORS.blue}, ${COLORS.purple})`,
            fontFamily: FONT,
            fontWeight: 800,
            fontSize: 42,
            color: COLORS.white,
            boxShadow: `0 24px 70px rgba(43,108,176,0.5)`,
            opacity: btnOp,
            scale: String(btnPop),
          }}
        >
          Solicita tu demostración
        </div>

        <div
          style={{
            marginTop: 46,
            display: "flex",
            gap: 40,
            alignItems: "center",
            opacity: domainOp,
            fontFamily: FONT,
            fontWeight: 600,
            fontSize: 32,
            color: COLORS.sub,
          }}
        >
          <span>turastreo.com</span>
          <span style={{ width: 8, height: 8, borderRadius: 8, background: NEUTRAL.lineStrong }} />
          <span>Rastreo QR + OBD</span>
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};
